import { UserType } from '@backoffice-frontend/graphql'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'

import { UserManagementAreaRoutes } from '@backoffice-frontend/user-management-api'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'

import { SettingsIcon } from '@moia-dev/pace-icons'

export const UserManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const { user } = useBackofficeLoggedInUser()
  const isPlatformAdmin = user?.userType === UserType.PlatformAdmin

  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={
        isPlatformAdmin
          ? UserManagementAreaRoutes.Users.route
          : UserManagementAreaRoutes.Groups.route
      }
      Icon={SettingsIcon}
    />
  )
}
